import React from "react";
import { createRoot } from "react-dom/client";
import SearchPageIsland from "./SearchPageIsland";

const mountNode = document.getElementById("search-page-island");

if (mountNode) {
  const rawConfig = mountNode.getAttribute("data-config");

  if (rawConfig) {
    const config = JSON.parse(rawConfig);
    createRoot(mountNode).render(<SearchPageIsland config={config} />);
  }
}
